// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1z_CX","right":"Footer_right__3S-dj","buttons":"Footer_buttons__3lRiq"};